export default __webpack_public_path__ + "locales/sk/EmptyView.json?hash=15a113af98b76d8e8df1b5fd448f4e17";